export default __webpack_public_path__ + "static/media/attorney_2_small.80d28cfc.png";